import { apiSlice } from './apiSlice'
import { type QualitySampling } from './qualitySamplingApi'

/**
 * Read-only fetch of one Quality Sampling record by id (Access
 * `frmQualityQrySamplingAddInfo` — "Sample Details" view). Reuses the live
 * `GET /quality-samplings/{id}` endpoint returning `QualitySamplingOut`.
 */
const samplingDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQualitySamplingById: builder.query<QualitySampling, number>({
      query: (id) => ({ url: `/quality-samplings/${id}` }),
      providesTags: (_result, _error, id) => [{ type: 'QualitySampling' as const, id }],
    }),
  }),
})

export const { useGetQualitySamplingByIdQuery } = samplingDetailsApi

export default samplingDetailsApi
